<template>
  <el-select
    :model-value="modelValue"
    :placeholder="label"
    multiple
    collapse-tags
    class="placeholder-as-label"
    @change="handleChange"
    @visible-change="searchInput = ''"
  >
    <div class="tw-h-8" />
    <el-input
      v-model="searchInput"
      clearable
      class="multiple-select__search-input"
    >
      <template #prefix>
        <icon-search />
      </template>
    </el-input>
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item[optionObjectLabelKey]"
      :value="item.id"
      class=""
      :class="[
        !searchInput || includesInputIgnoreDiacritics(item) ? '' : 'tw-hidden',
      ]"
    >
      <slot
        name="icon"
        :item="item"
      />
      <span>{{ item[optionObjectLabelKey] }}</span>
    </el-option>
  </el-select>
</template>
<script>

import { includesIgnoringDiacritics } from '@/helpers/searchWithDiacritics';

export default {
  name: 'MultiSelectWithSearch',
  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    handleChange: {
      type: Function,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    optionObjectLabelKey: {
      type: String,
      default: 'name',
    },
  },
  data() {
    return {
      searchInput: '',
    };
  },
  methods: {
    includesInputIgnoreDiacritics(option) {
      return includesIgnoringDiacritics(option[this.optionObjectLabelKey], this.searchInput);
    },
  },
};
</script>
